import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { AgentList } from "./list";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { AgentCreateInitializer } from "./create/initializer";
import { AgentDetailInitializer } from "./detailInitializer";

const AgentRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<AgentList />} />
        <Route path={`-create/*`} element={<AgentCreateInitializer />} />
        <Route path={`:agent/*`} element={<AgentDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default AgentRoute;
